import { Component, Mixins } from 'vue-property-decorator';
import TextTemplateMixin from './TextTemplateMixin';

@Component({})
export default class TextTemplate extends Mixins(TextTemplateMixin) {
  async mounted() {
    this.updateTextValue();
    if (this.component.css.fontFamily) await this.loadFont();
  }
}
